import { createTheme, createTheme as muiCreateTheme } from "@mui/material/styles";

const customeTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#00927c',
        },
        secondary: {
            main: '#ff5722',
        },
    },
});

export default customeTheme;


